import React from "react";
import reportAPI from "../../../../api/report";
import { FilterYearOnly } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExportCatheterLine } from "../../functions/Report.CountCatheterLine";
import {
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  FLEXDROPDOWN,
} from "../../../../utils/useStyle";

const ReportAllCountCatheter = ({ userDept }) => {
  const [loading, setLoading] = React.useState("");
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    picc: {
      adult: 0,
      kid: 0,
    },
    central: {
      adult: 0,
      kid: 0,
    },
    missingDataDOB: [],
    piccMissingDataDOB: 0,
    centralMissingDataDOB: 0,
    missingDataDOBtask: [],
    filteredRows: [],
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getCatheterAllReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching catheter all report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const piccAdult = data?.picc?.adult;
  const piccKid = data?.picc?.kid;

  const centralAdult = data?.central?.adult;
  const centralKid = data?.central?.kid;

  const piccMissing = data?.piccMissingDataDOB;
  const centralMissing = data?.centralMissingDataDOB;
  const totalMissing = piccMissing + centralMissing;

  const totalAdult = piccAdult + centralAdult;
  const totalKid = piccKid + centralKid;
  const totalPicc = piccAdult + piccKid + piccMissing;
  const totalCentral = centralAdult + centralKid + centralMissing;
  const total = totalAdult + totalKid + totalMissing;

  const submitExcelData = {
    Adult: {
      picc: piccAdult,
      central: centralAdult,
      total: totalAdult,
    },
    Child: {
      picc: piccKid,
      central: centralKid,
      total: totalKid,
    },
    Missing: {
      picc: piccMissing,
      central: centralMissing,
      total: totalMissing,
    },
    Total: {
      picc: totalPicc,
      central: totalCentral,
      total: total,
    },
  };

  return (
    <>
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                จำนวนผู้ป่วยที่ได้รับการใส่สายทั้งหมดต่อปี
                <div className={STYLEBODY}>
                  แยกเป็นผู้ป่วยเด็ก/ผู้ใหญ่ แยกตามเดือน ของปี "{year.label}"
                  ประเภทสาย "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearOnly year={year} setYear={setYear} />
                <ButtonExcel
                  onClick={() => {
                    ExportCatheterLine(submitExcelData, year);
                  }}
                  loading={loading}
                />
              </div>
            </div>

            <div className="relative overflow-x-auto mt-3">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      ปี {year.label}
                    </th>

                    <th scope="col" className="px-6 py-3">
                      PICC Line
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Central Line
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      Adult
                    </th>
                    <td className="px-6 py-4">{piccAdult}</td>
                    <td className="px-6 py-4">{centralAdult}</td>
                    <td className="px-6 py-4">{totalAdult}</td>
                  </tr>
                  <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      Child
                    </th>
                    <td className="px-6 py-4">{piccKid}</td>
                    <td className="px-6 py-4">{centralKid}</td>
                    <td className="px-6 py-4">{totalKid}</td>
                  </tr>
                  <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      Missing
                    </th>
                    <td className="px-6 py-4">{piccMissing}</td>
                    <td className="px-6 py-4">{centralMissing}</td>
                    <td className="px-6 py-4">{totalMissing}</td>
                  </tr>
                  <tr className="bg-white dark:bg-gray-800">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      Total
                    </th>
                    <td className="px-6 py-4">{totalPicc}</td>
                    <td className="px-6 py-4">{totalCentral}</td>
                    <td className="px-6 py-4">{total}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <i>
                  {" "}
                  *หมายเหตุ Missing หมายถึง
                  ผู้ป่วยที่ได้รับการใส่สายสำเร็จแต่ไม่ได้กรอกข้อมูลวันเกิด
                </i>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default ReportAllCountCatheter;
